import type { OkBody } from '../Models/ApiModel';
import { http } from './httpService';

export interface FullBackupModel {
  exportedAt: string;
  students: unknown[];
  payments: unknown[];
  slots: unknown[];
  contacts: unknown[];
  availability?: unknown[];
}

export interface FullImportPreview {
  preview: true;
  incomingStudents: number;
  incomingLessons: number;
  currentStudents: number;
  currentLessons: number;
}

export interface StudentCardsBackupModel {
  kind: 'magbit-student-cards';
  version: 1;
  exportedAt: string;
  students: unknown[];
  slots: unknown[];
  contacts: unknown[];
  availability: unknown[];
}

export interface CardImportPreview {
  preview: true;
  incoming: number;
  willAdd: number;
  willReplace: number;
  willRemove: number;
  /** What "replace" actually costs, counted on the server rather than guessed. */
  willRemoveLessons: number;
}

export interface CardImportResult {
  mode: 'merge' | 'replace';
  added: number;
  replaced: number;
  skipped: number;
  removed: number;
}

export const BackupService = {
  /** Everything: the roster and every lesson ever logged. */
  exportAll: () => http.get<FullBackupModel>('/export'),

  previewImportAll: (backup: Record<string, unknown>) =>
    http.post<FullImportPreview>('/import', { ...backup, preview: true }),

  importAll: (backup: Record<string, unknown>) => http.post<OkBody>('/import', backup),

  /**
   * The roster without the lesson history. Its own file so a tutor can move
   * who they teach without carrying years of lessons along.
   */
  exportStudentCards: () => http.get<StudentCardsBackupModel>('/students/export'),

  /** A dry run, so a confirmation can state exactly what replace will remove. */
  previewStudentCards: (backup: Record<string, unknown>, mode: 'merge' | 'replace') =>
    http.post<CardImportPreview>('/students/import', { ...backup, mode, preview: true }),

  importStudentCards: (backup: Record<string, unknown>, mode: 'merge' | 'replace') =>
    http.post<CardImportResult>('/students/import', { ...backup, mode })
};
